import { Component, Input } from '@angular/core';

@Component({
	selector: 'seira-paraiba-dividida-por-regiao-component',
	templateUrl: './paraiba-dividida-por-regiao-component.svg',
})
export class ParaibaDivididaPorRegiaoComponent {
	@Input() id!: string | number;
}
